import ListaPreciosVentaCreate from "./ListaPreciosVentaCreate.vue";
export default ListaPreciosVentaCreate;
